import { Injectable } from '@angular/core';

import { NavigationInterface } from '@shared/modules/navigation/components/navigation/navigation.component';

@Injectable()
export abstract class NavigationService {
  abstract getNavList(): NavigationInterface[];
}
